import { render, staticRenderFns } from "./image_lightbox.vue.js?vue&type=template&id=96b883ae&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./image_lightbox.vue?vue&type=template&id=96b883ae&vue3"
import script from "./image_lightbox.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./image_lightbox.vue?vue&type=script&lang=js&vue3"
export * from "./image_lightbox.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./image_lightbox.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports